import { getHexBounds } from '../hex/hexRenderUtils';

/**
 * Draws hatch lines over a bounds box; relies on clipping before calling.
 * Used for AoE-style ink shading and texture.
 */
export function hatch(
    ctx: CanvasRenderingContext2D,
    bounds: ReturnType<typeof getHexBounds>,
    angleRad: number,
    spacing: number,
    alpha: number,
    zoom: number,
): void {
    ctx.save();
    ctx.globalCompositeOperation = 'multiply';
    ctx.strokeStyle = `rgba(0,0,0,${alpha})`;
    ctx.lineWidth = 1 / zoom;

    const cx = (bounds.left + bounds.right) * 0.5;
    const cy = (bounds.top + bounds.bottom) * 0.5;
    ctx.translate(cx, cy);
    ctx.rotate(angleRad);
    ctx.translate(-cx, -cy);

    const w = (bounds.right - bounds.left) * 2;
    const h = (bounds.bottom - bounds.top) * 2;
    const left = cx - w * 0.5;
    const top = cy - h * 0.5;

    for (let y = top; y < top + h; y += spacing) {
        ctx.beginPath();
        ctx.moveTo(left, y);
        ctx.lineTo(left + w, y);
        ctx.stroke();
    }

    ctx.restore();
}

/**
 * Stippled dots for paper grain and terrain texture. Caller should clip.
 */
export function stipple(
    ctx: CanvasRenderingContext2D,
    rng: () => number,
    bounds: ReturnType<typeof getHexBounds>,
    count: number,
    alpha: number,
    zoom: number,
): void {
    ctx.fillStyle = `rgba(0,0,0,${alpha})`;
    const rMin = 0.45 / zoom;
    const rMax = 1.05 / zoom;

    for (let i = 0; i < count; i += 1) {
        const x = bounds.left + (bounds.right - bounds.left) * rng();
        const y = bounds.top + (bounds.bottom - bounds.top) * rng();
        const rad = rMin + (rMax - rMin) * rng();
        ctx.beginPath();
        ctx.arc(x, y, rad, 0, Math.PI * 2);
        ctx.fill();
    }
}
